import { render, staticRenderFns } from "./PayForForm.vue?vue&type=template&id=ea24628a"
import script from "./PayForForm.vue?vue&type=script&lang=js"
export * from "./PayForForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports